export default {
  key: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0, // 0px ~ 375px
    sm: 376, // 376px ~ 800px (含 800) -> 視為手機/單欄版面
    md: 801, // 801px 起 -> 視為平板/小桌機版面 (Layout 改變點)
    lg: 1201, // 1201px 起
    xl: 1441 // 1441px 起 -> 觸發最大寬度限制
  }
};
